import {connect} from 'react-redux';
import GroupNew from './GroupNew';
import {
  requestEntityList,
  fetchEntityListNotDeleted,
  entitiesListIsDirty,
  setEntityDetailId,
  selectEntityUi,
  createNewGroup
} from '../../redux/actions/groups';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    teams: state.teams
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestEntityList: () => {
      dispatch(requestEntityList());
    },
    fetchEntityListNotDeleted: () => {
      dispatch(fetchEntityListNotDeleted());
    },
    entitiesListIsDirty: value => {
      dispatch(entitiesListIsDirty(value));
    },
    setEntityDetailId: id => {
      dispatch(setEntityDetailId(id));
    },
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    },
    createNewGroup: data => {
      dispatch(createNewGroup(data));
    }
  };
};

const GroupNewContainer = connect(mapStateToProps, mapDispatchToProps)(GroupNew);

export default GroupNewContainer;
